import React from "react";
import { isAddressLocation } from "./matchCoordinates";

export default function AddressLocationNote({ match }) {
  return isAddressLocation(match) ? <p className="address-location-note">Approximate location from the venue address. Follow the organizer’s arrival instructions for the entrance.</p> : null;
}
